var map = {
	"./observing_body_feelings_15min_en.mp3": 29219,
	"./observing_body_feelings_15min_ko.mp3": 43480,
	"./observing_emotions_15min_en.mp3": 94993,
	"./observing_emotions_15min_ko.mp3": 70378,
	"./observing_thoughts_15min_en.mp3": 57873,
	"./observing_thoughts_15min_ko.mp3": 75530,
	"./stream_of_thoughts_15min_en.mp3": 22764,
	"./stream_of_thoughts_15min_ko.mp3": 13299,
	"./stream_of_thoughts_5min_en.mp3": 12111,
	"./stream_of_thoughts_5min_ko.mp3": 364
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2146;